import { render } from "./TodoView.vue?vue&type=template&id=3a3bff2c"
import script from "./TodoView.vue?vue&type=script&lang=js"
export * from "./TodoView.vue?vue&type=script&lang=js"

import "./TodoView.vue?vue&type=style&index=0&id=3a3bff2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__